import { formatGenres } from '@shared/genres'
import { cn } from '../lib/utils'
import type { Artist } from '../types'

export function ArtistGenreEyebrow({ artists, className }: { artists?: Pick<Artist, 'genres'>[] | null; className?: string }) {
  const label = formatGenres(artists?.flatMap(artist => artist.genres ?? []))
  if (!label) return null
  return (
    <p className={cn('text-[10px] font-semibold uppercase tracking-wider text-accent drop-shadow-sm truncate', className)}>{label}</p>
  )
}
